/**
 * The TCS solutions a tenant can be billed under, keyed by their Watchman Solution slug.
 * Single source for solution dropdowns so labels/options don't drift per-screen.
 *
 * NOT the same list as `features/portfolio` PORTFOLIO_SOLUTIONS — portfolio (case-study
 * galleries via portfolio-service) is only wired for rack-and-box/atelier/charter. Adding
 * a solution here does not imply portfolio support; add to PORTFOLIO_SOLUTIONS separately
 * once that integration actually exists for it.
 */
export interface SolutionOption {
  id: string;
  label: string;
}

export const SOLUTIONS: readonly SolutionOption[] = [
  { id: 'rack-and-box', label: 'Rack & Box' },
  { id: 'atelier', label: 'Atelier' },
  { id: 'charter', label: 'Charter' },
  { id: 'tradecraft', label: 'Tradecraft' },
  { id: 'adorn', label: 'Adorn' },
  { id: 'platter', label: 'Platter' },
] as const;
